"use strict";
var $forEach = require("../internals/array-iteration").forEach;
var arrayMethodIsStrict = require("../internals/array-method-is-strict");
var STRICT_METHOD = arrayMethodIsStrict("forEach");
module.exports = !STRICT_METHOD ? function forEach(callbackfn) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
} : [].forEach;
